/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateWorkPackageCategoryRequest } from '../../models/create-work-package-category-request';
import { WorkPackageCategoryDto } from '../../models/work-package-category-dto';

export interface CreateWorkPackageCategory$Params {
      body: CreateWorkPackageCategoryRequest
}

export function createWorkPackageCategory(http: HttpClient, rootUrl: string, params: CreateWorkPackageCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, createWorkPackageCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageCategoryDto>;
    })
  );
}

createWorkPackageCategory.PATH = '/v0/workPackageCategories/{id}';
